import React from 'react';
import './Title.css';

const Title = () => {
  return (
    <div className='f1 center'>
      <p className='title'>Meme Blur</p>
    </div>
  );
}

export default Title;